export const name = "app";
export const kind = "config";
export const values = {
  "languages": [
    {
      "value": "hu",
      "text": "P_(\"Language\", \"hungarian\")"
    },
    {
      "value": "en",
      "text": "P_(\"Language\", \"english\")"
    }
  ],
  "addIcon": "iconamoon:sign-plus-square-duotone",
  "addIconAlt": "fa-plus",
  "assignIcon": "material-symbols:assignment-return-outline",
  "attachmentIcon": "fa-paperclip",
  "deleteIcon": "icon-park-solid:delete-five",
  "downloadIcon": "ic:baseline-download",
  "editIcon": "fa-pen",
  "exportIcon": "mdi:export",
  "externalLinkIcon": "iconamoon:link-external-duotone",
  "importIcon": "mdi:import",
  "lockIcon": "material-symbols:lock",
  "mergeIcon": "mdi:merge",
  "previewIcon": "icon-park-outline:preview-open",
  "priceIndexingIcon": "material-symbols:price-change-outline",
  "processIcon": "mdi:cog",
  "pullDataIcon": "material-symbols:download-2",
  "reloadIcon": "ooui:reload",
  "saveIcon": "material-symbols:save",
  "submitIcon": "formkit:submit",
  "uploadIcon": "mdi:folder-upload",
  "magicWandIcon": "vaadin:magic",
  "colors": {
    "inactiveRed": "rgb(220, 53, 69)",
    "activeGreen": "rgb(40, 167, 69)"
  },
  "bgClass": {
    "inactive": "bg-yellow-100",
    "locked": "bg-gray-100"
  },
  "statuses": {
    "colors": {
      "new": "gray-500",
      "pending": "yellow-500",
      "retry": "yellow-500",
      "approved": "purple-500",
      "started": "blue-500",
      "running": "blue-500",
      "completed": "green-500",
      "invalid": "red-500",
      "failed": "red-500",
      "cancelled": "gray-500",
      "deleted": "gray-500"
    }
  },
  "statusVariants": {
    "draft": "light",
    "deleted": "light",
    "pending": "light",
    "retry": "light",
    "running": "primary",
    "cancelled": "warning",
    "completed": "success",
    "archived": "light",
    "failed": "danger",
    "invalid": "danger"
  },
  "fileTypeIcons": {
    "default": "vscode-icons:file-type-binary",
    "pdf": "vscode-icons:file-type-pdf2",
    "doc": "vscode-icons:file-type-word",
    "docx": "vscode-icons:file-type-word",
    "xls": "vscode-icons:file-type-excel",
    "xlsx": "vscode-icons:file-type-excel",
    "txt": "vscode-icons:file-type-text",
    "zip": "vscode-icons:file-type-zip2",
    "ps": "vscode-icons:file-type-photoshop2",
    "md": "vscode-icons:file-type-markdown",
    "bmp": "vscode-icons:file-type-image",
    "jpg": "vscode-icons:file-type-image",
    "jpeg": "vscode-icons:file-type-image",
    "avi": "vscode-icons:file-type-video"
  },
  "account": {
    "icon": "fa-wallet",
    "createAccountIcon": "mdi:wallet-plus",
    "cashBook": {
      "icon": "fa-cash-register"
    },
    "bankAccount": {
      "icon": "fa-credit-card"
    },
    "badDebtJournal": {
      "icon": "ph:box-arrow-down-fill"
    },
    "reconciliationOfInvoices": {
      "icon": "tabler:arrows-diff"
    }
  },
  "accountsDailyFlow": {
    "icon": "fa-funnel-dollar"
  },
  "accountStatementReport": {
    "icon": "icon-park-solid:table-report"
  },
  "attachment": {
    "icon": "fa-paperclip"
  },
  "billingList": {
    "color": "indigo-400",
    "icon": "tdesign:bill",
    "createItemIcon": "tdesign:bill"
  },
  "forms": {
    "defaultLabelAlign": "right"
  },
  "claim": {
    "icon": "fa-search-dollar"
  },
  "company": {
    "colorCode": "cyan",
    "icons": {
      "own": "nrk:home-active",
      "partner": "fa-users"
    },
    "colors": {
      "own": "orange-400",
      "partner": "blue-400"
    },
    "role": {
      "colorCodes": {
        "own": "orange-400",
        "partner": "blue-400"
      }
    },
    "type": {
      "colorCodes": {
        "customer": "green-400",
        "vendor": "blue-400",
        "both": "orange-400"
      }
    }
  },
  "contract": {
    "icon": "mdi:contract-outline",
    "createContractIcon": "mdi:contract-outline",
    "status": {
      "variantMap": {
        "draft": "light",
        "approved": "success",
        "signed": "success",
        "active": "primary",
        "ended": "warning",
        "terminated": "warning",
        "rescinded": "danger",
        "archived": "light"
      }
    },
    "views": {
      "contractEvents": {
        "icon": "material-symbols-light:event-list"
      },
      "overlappingRevisions": {
        "icon": "openmoji:overlapping-white-and-black-squares"
      }
    }
  },
  "contractFee": {
    "icon": "fa-money-bill"
  },
  "dashboard": {
    "icon": "fa-home"
  },
  "dunningLetter": {
    "color": "indigo-400",
    "icon": "fa-mail-bulk"
  },
  "jobs": {
    "icon": "fa-cogs"
  },
  "fixedAsset": {
    "icon": "fa-chair",
    "createFixedAssetIcon": "fa-chair",
    "types": {
      "general": "P_(\"FixedAssetTypes\", \"General\")",
      "waste_bin": "P_(\"FixedAssetTypes\", \"Waste Bin\")"
    }
  },
  "invoice": {
    "color": "red-400",
    "icon": "fa-file-invoice",
    "customerInvoiceIcon": "fa-file-invoice",
    "vendorInvoiceIcon": "fa-file-invoice",
    "draftInvoicesIcon": "fa-layer-group",
    "invoiceStatusVariants": {
      "draft": "warning",
      "received": "warning",
      "filed": "primary",
      "recorded": "primary",
      "accounted": "info",
      "completed": "success",
      "void": "danger"
    },
    "types": {
      "colorCodes": {
        "normal": {
          "bg": "blue-200",
          "text": "blue-700"
        },
        "correction": {
          "bg": "yellow-500",
          "text": "yellow-800"
        },
        "storno": {
          "bg": "red-300",
          "text": "red-800"
        },
        "proforma": {
          "bg": "gray-300",
          "text": "gray-800"
        }
      }
    }
  },
  "invoiceGeneration": {
    "icon": "vaadin:magic"
  },
  "register": {
    "color": "purple-400",
    "icon": "fa:book",
    "createEntry": "fa:book"
  },
  "invoiceRegister": {
    "color": "purple-400",
    "icon": "mdi:invoice-check",
    "createEntry": "mdi:invoice-check"
  },
  "letterRegister": {
    "color": "cyan-400",
    "icon": "healthicons:register-book",
    "createEntry": "fluent:book-add-20-regular",
    "registers": [
      {
        "value": "in",
        "name": "Bejövő levelek jegyzéke"
      },
      {
        "value": "out",
        "name": "Kimenő levelek jegyzéke"
      }
    ]
  },
  "meter": {
    "icon": "fa-weight",
    "addMeterIcon": "fa-plus-circle"
  },
  "meterReplacement": {
    "icon": "fa-exchange-alt"
  },
  "meterTypes": {
    "pulse": {
      "description": "P_(\"MeterTypes\", \"Pulse meter\")",
      "icon": "fa-wifi"
    },
    "water": {
      "description": "P_(\"MeterTypes\", \"Water meter\")",
      "icon": "fa-tint"
    },
    "heat": {
      "description": "P_(\"MeterTypes\", \"Heat meter\")",
      "icon": "fa-thermometer-half"
    },
    "electricity": {
      "description": "P_(\"MeterTypes\", \"Electric meter\")",
      "icon": "fa-bolt"
    },
    "gas": {
      "description": "P_(\"MeterTypes\", \"Gas meter\")",
      "icon": "fa-burn"
    },
    "cost_allocator": {
      "description": "P_(\"MeterTypes\", \"Cost allocator\")",
      "icon": "fluent:arrow-split-24-filled"
    }
  },
  "meterConsumption": {
    "icon": "memory:range",
    "createMeterConsumptionIcon": "lucide:git-pull-request-create"
  },
  "meterReading": {
    "icon": "fa-file-signature"
  },
  "meterAutoReading": {
    "icon": "fa-ethernet"
  },
  "parkingSpot": {
    "icon": "fa-car"
  },
  "payment": {
    "color": "orange-400",
    "icon": "material-symbols:payments-sharp",
    "paymentsList": {
      "icon": "hugeicons:transaction"
    },
    "banking": {
      "icon": "icon-park-solid:bank-transfer"
    },
    "cash": {
      "icon": "material-symbols:payments-sharp"
    }
  },
  "product": {
    "icon": "fa-tag",
    "addProductIcon": "fa-tag",
    "colorCodes": {
      "service": "teal",
      "product": "indigo",
      "article": "pink",
      "tool": "blue",
      "raw_material": "gray"
    }
  },
  "project": {
    "icon": "ant-design:project-outlined",
    "addProjectIcon": "ant-design:project-outlined"
  },
  "property": {
    "colorCode": "orange",
    "icon": "fa-building",
    "addPropertyIcon": "fa-building"
  },
  "realPropertyUnits": {
    "icon": "fa-building"
  },
  "rental": {
    "colorCode": "indigo",
    "icon": "mdi:house-city-outline",
    "addRentalIcon": "mdi:house-city-outline"
  },
  "settings": {
    "icon": "mdi:cog"
  },
  "tariff": {
    "icon": "ion:pricetag"
  },
  "vatPeriod": {
    "icon": "guidance:calendar"
  },
  "wasteBin": {
    "icon": "fa-dumpster",
    "createWasteBinIcon": "fa-dumpster"
  },
  "worksheet": {
    "color": "blue-400",
    "colorCode": "blue",
    "icon": "tdesign:task",
    "createWorksheetIcon": "tdesign:task"
  }
};

export default {
  name: "app",
  kind: "config",
  ...values,
};
